(function (upp) {
    'use strict';


    upp.controller('upp.loyalty.LoyaltyCardCtrl', ['loyaltyService', '$scope', '$routeParams', 'appi', '$sce', '$timeout', '$rootScope',
        function (loyaltyService, $scope, $routeParams, appi, $sce, $timeout, $rootScope) {

            appi.ui.changeActualOption({moduleKey2Display: 'loyaltycard', navbarKey: 'loyaltycard'}, "/loyaltycard");
            appi.ui.showPageLoadingMsg();

            /**
             * Set the scope the data needed when we have a user logged
             * @param userId int user logged
             */
            var setStamps = function(userId) {

                $scope.userId = userId;
                loyaltyService.getCurrentStampsUser(loyaltyId, $scope.userId)
                    .then(function (response) {
                        $scope.loyalty.numberCurrentStamps = response.stamps;
                    }, function () {
                        appi.ui.showNetworkError();
                    });

                loyaltyService.getQrImage(loyaltyId)
                    .then(function (response) {
                        $scope.loyalty.qrImage = response.result;
                    }, function () {
                        appi.ui.showNetworkError();
                    });
            };

            var loyaltyId = appi.utils.getIdFromParams($routeParams.info);
            var checker;
            var isMock = window.getQueryParams().mock === "true";

            $scope.sections = {
                main: 'main',
                validation: 'validation',
                exception: 'exception',
                gift: 'gift'
            };

            $scope.section = $scope.sections.main;
            $scope.loyalty = {};
            $scope.stamps = [];
            $scope.readonlyCode = false;


            if (!isMock) {

                loyaltyService.getLoyaltyCard(loyaltyId)
                    .then(function (loyalty) {

                        loyalty.description = $sce.trustAsHtml(loyalty.description);

                        if (loyalty.exceptions) {
                            loyalty.exceptions = $sce.trustAsHtml(loyalty.exceptions);
                            var dateFrom = loyalty.validFrom.split(" ")[0].split("-");
                            var newParsedFrom = dateFrom[0]+"/"+dateFrom[1]+"/"+dateFrom[2];
                            loyalty.validFrom = new Date(newParsedFrom);
                            if (loyalty.validUntil == null) {
                                loyalty.validUntil = null;
                            }
                            else {
                                var dateUntil = loyalty.validUntil.split(" ")[0].split("-");
                                var newParsedUntil = dateUntil[0]+"/"+dateUntil[1]+"/"+dateUntil[2];
                                loyalty.validUntil = new Date(newParsedUntil);
                            }
                        }

                        $scope.loyalty = loyalty;

                        appi.security.getAuthentication().then(function(auth){
                            if (auth.type != 'anonymous') {
                                setStamps(auth.principal.userId);
                            }
                        });

                        appi.ui.hidePageLoadingMsg();
                    }, function () {
                        appi.ui.showNetworkError();
                    });
            } else {
                appi.ui.hidePageLoadingMsg();
            }

            $scope.showMainWindow = function () {
                checker.cancel();
                $scope.section = $scope.sections.main;
            };

            $scope.showValidationCodeWindow = function () {

                appi.security.getAuthentication().then(function(auth){
                    if (auth.type != 'anonymous') {
                        $scope.code = '';
                        $scope.validCodeContent = false;
                        $scope.form.code.$setValidity("code", true);
                        $scope.form.code.$setValidity("dailyLimit", true);
                        $scope.section = $scope.sections.validation;

                        // event fire when a new stamp fire
                        checker = loyaltyService.checkStamped(loyaltyId, auth.principal.userId, $scope.loyalty.numberCurrentStamps);
                        checker.onStamp(function(stamps) {
                            $timeout(function () {
                                $scope.loyalty.numberCurrentStamps = stamps;
                                $scope.validCodeContent = true;
                                $scope.readonlyCode = true;
                                $scope.showSuccessWindow();
                            }, 1000);
                        });
                        var watcher = $rootScope.$on('$routeChangeStart', function($event, next, current) {
                            if (checker && checker.cancel) {
                                checker.cancel();
                            }
                            watcher();
                        });
                    }
                    else {
                        appi.security.securable({showError: false})
                            .then(function (auth) {
                                if (auth.type == "anonymous") {
                                    return;
                                }
                                setStamps(auth.principal.userId);
                            });
                    }
                });

            };

            $scope.showConditionsWindow = function () {
                $scope.section = $scope.sections.exception;
            };

            $scope.showGiftWindow = function () {
                $scope.section = $scope.sections.gift;
                $scope.loyalty.numberCurrentStamps = 0;
            };

            $scope.showSuccessWindow = function () {
                $scope.validCodeContent = false;
                if ($scope.loyalty.numberStamps == $scope.loyalty.numberCurrentStamps) {
                    $scope.showGiftWindow();
                }
                else {
                    $scope.showMainWindow();
                }
                $scope.readonlyCode = false;
            };

            $scope.$watch('loyalty.numberStamps + " " + loyalty.numberCurrentStamps', function() {
                $scope.stamps = [];

                for (var i = 0; i < $scope.loyalty.numberStamps - 1; i++) {
                    $scope.stamps.push((i < $scope.loyalty.numberCurrentStamps));
                }
            });

            // Quit errors on change
            $scope.onChangeCode = function (form) {
                form.code.$setValidity("code", true);
                form.code.$setValidity("dailyLimit", true);
            };

            $scope.validateCode = function (form) {

                var validCode = form.code.$viewValue;

                if (validCode.length == 4) {

                    loyaltyService.addCode(loyaltyId, $scope.userId, validCode)
                        .then(function (valid) {

                            if (angular.equals(valid, 'dailylimit')) {
                                form.code.$setValidity("dailyLimit", false);
                            }
                            else if (valid) {
                                $scope.loyalty.numberCurrentStamps++;
                                $scope.validCodeContent = true;
                                form.code.$setValidity("code", true);
                                form.code.$setValidity("dailyLimit", true);
                                $scope.readonlyCode = true;
                                $timeout(function () {
                                    $scope.showSuccessWindow();
                                }, 2000);
                            }
                            else {
                                form.code.$setValidity("code", false);
                            }
                        }, function () {
                            appi.ui.showNetworkError();
                        });

                }
                else if (validCode.length > 0) {
                    form.code.$setValidity("code", false);
                }
            };
        }
    ]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/loyalty/controllers/loyalty-card-controllers.js